import { RenderElementProps } from 'slate-react';

export const ELEMENT_OUTLINE_STATEMENT = 'outline-statement';

export interface OutlineStatementPluginOptions {
  isReadOnly?: boolean;
}

export interface BaseOutlineStatementProps
  extends RenderElementProps,
    OutlineStatementPluginOptions {}
